<template>
  <span class="text-muted font-italic" v-html="info"></span>
</template>

<script>
export default {
  name: 'required-fields-info',
  data() { return { info: this.$t('COMMON.REQUIRED_FIELDS_INFO', {asterix: '<span class="text-success"><strong>*</strong></span>'})}; }
}
</script>